import PropTypes from "prop-types"
import React, { useState } from "react"
import InfiniteScroll from "react-infinite-scroller"
import { useFetch } from "../hooks";
import YouTube from "react-youtube"

const Videos = () => {
  const [fullYoutubeList] = useFetch('../php/youtube/youtube.json');
  const data = fullYoutubeList.sort(function compare(a, b) {
    if (a.publishedAt < b.publishedAt) {
      return -1;
    }
    if (a.publishedAt > b.publishedAt) {
      return 1;
    }
    // a must be equal to b
    return 0;
  }).reverse();
  const [vidList, setVidList] = useState([])

  const [showModal, setShowModal] = useState(false)
  const [videoId, setVideoId] = useState()
  const [hasMore, setHasMore] = useState(false)

  if ( vidList.length === 0 && data.length !== 0) {
    setVidList(data.slice(0, 12));
    setHasMore(true)
  }
  
  const loadFunc = () => {
    setTimeout(() => {
      let more = vidList.length + 12;
      let isMore = true;
      if (data.length < vidList.length + 12) {
        more = data.length;
        isMore = false;
      }
      let nextVids = data.slice(vidList.length, more);
      setVidList([...vidList, ...nextVids])
      setHasMore(isMore);
    }, 500)
  }

  const onClick = (videoId) => {
    setShowModal(true);
    setVideoId(videoId);
  }
  const onModalClose = () => {
    setShowModal(false);
    setVideoId(undefined);
  }
  
  const onReady = (event) => {
		event.target.playVideo();
	}
  const playerVars = {
      autoplay: 1,
      controls: 0,
      rel: 0,
      showinfo: 0,
      playsinline: 1,
      mute: 1,
      modestbranding: 1,
      iv_load_policy: 3,
      onReady: onReady
  }
  const renderYoutubePlayer = () => {
    if(showModal){
      return <YouTube videoId={videoId} {...playerVars}></YouTube>
    } else {
      return
    }
  }

  const renderFigure = (thumbnail) => {
    const figStyle = {
      backgroundImage: `url(${thumbnail})`
    };
    return <div className="image is-16by9 vidCover" style={figStyle}></div>;
  }
  let modalClasses = "modal";
  if ( showModal ) {
    modalClasses += " is-active";
  }
  console.log('hasMore', hasMore)
  return (
    
      <InfiniteScroll
        pageStart={0}
        loadMore={loadFunc}
        hasMore={hasMore}
        loader={
          <div className="loaderWrapper" key={ 0}>
            <div className="loader eye" >
              <img src={`../images/animations/CEI_Loading_Eyes.gif`} alt="Animated eye logo" width="50" height="50" className=""/>
            </div>
          </div>
        }
      >
        <div className="section videos">
          <div className="container">
            <div className="columns is-multiline is-mobile">
              {/* {vidList.map((e, i) => {
                let classNames = "column is-one-third-tablet"
                classNames += i === 2 && !vidSelected ? " is-full-mobile" : " is-half-mobile"
                if ( e.selected ){
                  classNames += " is-full"
                }
                return (
                  <div className={classNames} key={i} onClick={()=>videoClickHandler(e,i)}>
                    <Img
                      fluid={e.childImageSharp.fluid}
                      alt="video placeholder"
                    />
                  </div>
                )
              })} */}
              {vidList.map((e, i) => {
                let classNames = "column is-one-third-tablet is-half-mobile vidWrapper"
                return (
                  <div className={classNames} key={i} onClick={()=>onClick(e.id)}>
                    {renderFigure(e.thumbnail)}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <div className={modalClasses}>
          <div className="modal-background" onClick={onModalClose}></div>
          <div className="modal-content">
            {renderYoutubePlayer()}
            <button className="modal-close is-large" aria-label="close" onClick={onModalClose}></button>
          </div>
          
        </div>
      </InfiniteScroll>
  )
}

Videos.propTypes = {
  videos: PropTypes.array.isRequired,
}

export default Videos
